module.exports = __webpack_public_path__ + "img/hero-bg.480bb6bd.jpeg";